module.exports = __webpack_public_path__ + "img/konsultasi-inactive.b207f05.png";